var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle42ASelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M22.5 53a1.5 1.5 0 0 1-1.5-1.5v-43A1.5 1.5 0 0 1 22.5 7h15A1.5 1.5 0 0 1 39 8.5v43a1.5 1.5 0 0 1-1.5 1.5h-15Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M6 50v-3h10v1.237a2.5 2.5 0 0 1-2.749 2.488L6 50ZM6 10v3h10v-1.238a2.5 2.5 0 0 0-2.749-2.487L6 10ZM6 47V13h10v34z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M6 9v42"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M54 10v3H44v-1.238a2.5 2.5 0 0 1 2.749-2.487L54 10ZM54 50v-3H44v1.237a2.5 2.5 0 0 0 2.749 2.488L54 50ZM54 13v34H44V13z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M54 51V9"
})));
SvgRectangle42ASelected.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle42ASelected);
export default ForwardRef;